import _classCallCheck from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// tslint:disable:max-classes-per-file

/**
 * The error that is thrown when an argument passed in is null.
 *
 * @export
 * @class ArgumentNullError
 * @extends {Error}
 */
export var ArgumentNullError = /*#__PURE__*/function (_Error) {
  _inherits(ArgumentNullError, _Error);

  var _super = _createSuper(ArgumentNullError);

  /**
   * Creates an instance of ArgumentNullError.
   *
   * @param {string} argumentName - Name of the argument that is null
   *
   * @memberOf ArgumentNullError
   */
  function ArgumentNullError(argumentName) {
    var _this;

    _classCallCheck(this, ArgumentNullError);

    _this = _super.call(this, argumentName);
    _this.name = "ArgumentNull";
    _this.message = argumentName;
    return _this;
  }

  return ArgumentNullError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * The error that is thrown when an invalid operation is performed in the code.
 *
 * @export
 * @class InvalidOperationError
 * @extends {Error}
 */

export var InvalidOperationError = /*#__PURE__*/function (_Error2) {
  _inherits(InvalidOperationError, _Error2);

  var _super2 = _createSuper(InvalidOperationError);

  /**
   * Creates an instance of InvalidOperationError.
   *
   * @param {string} error - The error
   *
   * @memberOf InvalidOperationError
   */
  function InvalidOperationError(error) {
    var _this2;

    _classCallCheck(this, InvalidOperationError);

    _this2 = _super2.call(this, error);
    _this2.name = "InvalidOperation";
    _this2.message = error;
    return _this2;
  }

  return InvalidOperationError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * The error that is thrown when an object is disposed.
 *
 * @export
 * @class ObjectDisposedError
 * @extends {Error}
 */
// tslint:disable-next-line:max-classes-per-file

export var ObjectDisposedError = /*#__PURE__*/function (_Error3) {
  _inherits(ObjectDisposedError, _Error3);

  var _super3 = _createSuper(ObjectDisposedError);

  /**
   * Creates an instance of ObjectDisposedError.
   *
   * @param {string} objectName - The object that is disposed
   * @param {string} error - The error
   *
   * @memberOf ObjectDisposedError
   */
  function ObjectDisposedError(objectName, error) {
    var _this3;

    _classCallCheck(this, ObjectDisposedError);

    _this3 = _super3.call(this, error);
    _this3.name = objectName + "ObjectDisposed";
    _this3.message = error;
    return _this3;
  }

  return ObjectDisposedError;
}( /*#__PURE__*/_wrapNativeSuper(Error));